module.exports = __webpack_public_path__ + "img/item-2.5bdce3c8.png";